import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction('student/FINISH_PRODUCT_TOUR'));
